module.exports = __webpack_public_path__ + "img/usuarios_inversionista.58e5bd3c.webp";